import { Show, type JSX } from "solid-js";

export default function PageHero(props: {
  kicker?: string;
  title: string;
  line?: string;
  aside?: JSX.Element;
}) {
  return (
    <header class="page-hero">
      <div class="page-hero-copy">
        <h1 class="page-title">{props.title}</h1>
        <Show when={props.line}>
          <p class="page-hero-line">{props.line}</p>
        </Show>
      </div>
      <Show when={props.aside}>
        <div class="page-hero-aside">{props.aside}</div>
      </Show>
    </header>
  );
}
